import { ReactComponent as ArrowDownBracket } from '@assets/icons/arrow_down_bracket.svg';
import { ReactComponent as ArrowUpBracket } from '@assets/icons/arrow_up_bracket.svg';
import { ReactComponent as FocusedArrowDownBracket } from '@assets/icons/focused_arrow_down_bracket.svg';
import { ReactComponent as FocusedArrowUpBracket } from '@assets/icons/focused_arrow_up_bracket.svg';
import { KeyPressDetails, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC } from 'react';

import * as S from './styles';

interface FocusableButtonProps {
  isUp: boolean;
  onEnterPress: (props: object, details: KeyPressDetails) => void;
}

const VerticalScrollArrow: FC<FocusableButtonProps> = (props) => {
  const { isUp, onEnterPress } = props;

  const { ref, focused } = useFocusable({
    onEnterPress
  });

  return (
    <div ref={ref}>
      {isUp ? (
        focused ? (
          <FocusedArrowUpBracket css={S.icon} />
        ) : (
          <ArrowUpBracket css={S.icon} />
        )
      ) : focused ? (
        <FocusedArrowDownBracket css={S.icon} />
      ) : (
        <ArrowDownBracket css={S.icon} />
      )}
    </div>
  );
};

export default VerticalScrollArrow;
